import { Registration } from "./Registration";
import { Answer } from "./Answer";
import { Language } from "./Language";
import { Region } from "./Region";

export interface User {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    gender: "male" | "female";
    birthTimeStamp: number;
    iban: string;
    admin: boolean;
    howFound: string;
    telephoneNumber?: string;
    registrations?: Registration[];
    answers?: Answer[];
    registerFriend?: User;
    passwordHash?: string;
    refreshCount?: number;
    registerFriendRewarded: boolean;
    activeRegionName: string;
    activeRegion?: Region;
    createdTimeStamp: number;
    enableEmail: boolean;
    enableNotificationEmail: boolean;
    language?: Language;
}

export function calculateAge(birthDate: Date) {
    var today = new Date();
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
    return age;
}
